import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { Button, Card, Form, Modal, Spinner } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import ErrorMessage from '../components/ErrorMessage'
import { useStore } from '../../app/stores/store'
import PhotoWidgetCropper from '../components/photo/PhotoWidgetCropper'
import SinglePhotoDropzone from '../components/photo/SinglePhotoDropzone'

function EditAvatar({ handleClose }: any) {
  const { profileStore } = useStore()
  const [error, setError] = useState('')
  const [loadingBtn, setLoadingBtn] = useState(false)
  const { t } = useTranslation()
  const [file, setFile] = useState<any>(null)
  const [cropper, setCropper] = useState<any>(null)
  const [wizard, setWizard] = useState<number>(1)

  const handleSubmit = async (e: any) => {
    setLoadingBtn(true)
    e.preventDefault()

    if (cropper) {
      cropper.getCroppedCanvas().toBlob((blob: Blob) => {
        profileStore
          .changeUserAvatar(blob)
          .catch((err) => console.log(err.response))
          .finally(() => {
            handleClose()
            setLoadingBtn(false)
          })
      })
    }
  }

  const handleNext = () => {
    setWizard(wizard + 1)
  }

  const handlePrev = () => {
    setWizard(wizard - 1)
  }

  const buttons = [
    {
      title: t('cancel'),
      onClick: handleClose,
      className: 'text-white payment-button-cancel',
      type: 'button',
      show: wizard === 1,
    },
    {
      title: t('previous'),
      className: 'text-white payment-button-cancel',
      onClick: handlePrev,
      type: 'button',
      show: wizard === 2 || wizard === 3,
    },
    {
      title: t('next'),
      className: 'text-white payment-button-tryagain',
      onClick: handleNext,
      type: 'button',
      show: wizard === 2,
    },
    {
      title: loadingBtn ? <Spinner animation='border' variant='light' /> : t('upload'),
      className: 'text-white payment-button-tryagain',
      type: 'submit',
      show: wizard === 3,
    },
  ]

  return (
    <Card className='newFont prevent-select'>
      <Modal.Header>
        <p className='login-card-title'>{t('avatar_page.account_avatar_title')}</p>
        <Button variant='inherit' onClick={handleClose} className='close me-2 d-flex justify-content-center align-items-center p-0'>
          <i className='fa-regular fa-x icon-size' />
        </Button>
      </Modal.Header>
      <Modal.Body className='card-padding card-font-size'>
        <Form onSubmit={handleSubmit}>
          <Form.Group className='mb-3 profile-password'>
            <div className='d-flex flex-column'>
              {wizard === 1 && (
                <>
                  <p>{t('avatar_page.step_1')}</p>
                  <SinglePhotoDropzone nextStep={handleNext} setFiles={setFile} />
                </>
              )}
              {wizard === 2 && file && (
                <div>
                  <p>{t('avatar_page.step_2')}</p>
                  <PhotoWidgetCropper setCropper={setCropper} imagePreview={file[0].preview} />
                </div>
              )}
              {wizard === 3 && (
                <div>
                  <p>{t('avatar_page.step_3')}</p>
                  {file && (
                    <div className='d-flex justify-content-center'>
                      <img
                        src={cropper.getCroppedCanvas().toDataURL()}
                        style={{ height: 200, width: 200, borderRadius: '50%' }}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </Form.Group>
          {error && typeof error === 'string' && (
            <ErrorMessage text={error} setError={() => setError('')} />
          )}
          <div className='auction-create-buttons'>
            {buttons.map(
              (button, index) =>
                button.show && (
                  <button
                    key={index}
                    onClick={button.onClick}
                    disabled={loadingBtn}
                    type={button.type === 'submit' ? 'submit' : 'button'}
                    className={`text-white ${button.className}`}
                  >
                    {button.title}
                  </button>
                ),
            )}
          </div>
        </Form>
      </Modal.Body>
    </Card>
  )
}
export default observer(EditAvatar)
